// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__3XESE","image_404":"NotFound_image_404__1e5ft"};